import { render, staticRenderFns } from "./RattachmentForm.vue?vue&type=template&id=073d4644"
import script from "./RattachmentForm.vue?vue&type=script&lang=js"
export * from "./RattachmentForm.vue?vue&type=script&lang=js"
import style0 from "./RattachmentForm.vue?vue&type=style&index=0&id=073d4644&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports